import {AfterViewInit, Injectable, OnInit} from '@angular/core';
import {ServerService} from "./server.service";
import {CKWebSocket, RoomName, WebsocketService} from "./websocket.service";
import {Subject, Subscription} from "rxjs";

@Injectable({
   providedIn: 'root'
})
export class BadgeService {
   public badgeCount: number | undefined = 0;

   private wsSocket: CKWebSocket | null = null;
   wsSocket$: Subscription|null = null
   private triggerEvent = new Subject<void>();

   constructor(private serverSrv:ServerService,
               private wsSrv: WebsocketService) { }


   triggerAction() {
      this.triggerEvent.next();
   }

   getTriggerEvent() {
      this.wsSocket = this.wsSrv.connect(RoomName.BADGE_DA_APPROVARE)
      if(this.wsSocket){
         this.wsSocket$ = this.wsSocket.onMessage.subscribe(data=> {
            console.log(data)
            this.badgeCount = data.total
         })
      }
      return this.triggerEvent.asObservable();
   }

   getBadgeCount(): number | undefined {
      this.serverSrv.get(null, `/api/da_approvare`).then(res => {
         this.badgeCount = res.da_approvare
      }).catch(err => {
         console.error(err)
      })
      return this.badgeCount;
   }

   updateBadgeCount(count: number): void {
      this.badgeCount = count;
   }

}
